import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import ArrowRight from "../Icons/ArrowRight";
import ArrowDown from "../Icons/ArrowDown";
import ArrowUp from "../Icons/ArrowUp";

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },

  guide: {
    boxShadow: '0px 0px 5px #00000026',
    borderRadius: '5px',
    padding: '40px',
    marginBottom: '30px',
    cursor: 'pointer',
    pointerEvents: 'auto',
  },

  section: {
    // ヘッダを固定しているためアンカーリンクがずれてしまうため
    // marginTopでヘッダ要素分マイナスにする
    marginTop: '-140px',
    paddingTop: '140px',
    pointerEvents: 'none',
  },

  about: {
    width: 680,
    fontWeight: 'bold',
    fontSize: 17,
    letterSpacing: '0.34px',
    textIndent: '0.34px',
  },

  detail: {
    fontSize: 15,
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    whiteSpace: 'break-spaces',
  },

  imgContainer: {
    padding: '20px 20px 15px 20px',
    background: '#F4F5F6',
    marginTop: '15px',
  },

  img: {
    width: '100%',
  },

  caution: {
    margin: '15px 0 25px 0',
    padding: '15px',
    color: '#181819',
    background: '#F4F5F6',
    borderRadius: '3px',
    fontSize: 15,
    letterSpacing: '0.3px',
    textIndent: '0.3px',
  },

  arrow: {
    margin: 'auto 0',
  },

  question: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  answer: {
    width: 680,
    marginTop: 15,
  },

  subheading: {
    fontSize: 28,
    marginBottom: 25,
    letterSpacing: '0.55px',
    textIndent: '0.55px',
    lineHeight: '1.5em',
  },

  articleLink: {
    padding: '25px',
    border: '1px solid #195AFF',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 15px #0000001A',
      border: '1px solid #195AFF',
    }
  },

  linkText: {
    width: '620px',
  },

  link: {
    color: '#195AFF',
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    textDecoration: 'underline',
  },
});

class HowToFaq extends React.Component {
  state = {
    showAnswerExe1: false,
    showAnswerExe2: false,
    showAnswerExe3: false,
    showAnswerExe4: false,
    showAnswerOrdering1: false,
    showAnswerOrdering2: false,
    showAnswerOrdering3: false,
    showAnswerOrdering4: false,
    showAnswerAfterOrder1: false,
    showAnswerAfterOrder2: false,
    showAnswerAfterOrder3: false,
  }

  toggleAnswer = (property) => {
    this.setState({
      [property]: !this.state[property],
    });
  };

  renderArticleLink = (about, detail, link) => {
    const { classes } = this.props;
    return (
      <div className={classes.articleLink} onClick={() => this.props.goTo(link)}>
        <div className={classes.linkText}>
          <div className={classes.about} style={{ fontSize: 15 }}>
            {about}
          </div>
          <div className={classes.detail}>
            {detail}
          </div>
        </div>
        <ArrowRight color="#195AFF" width={26} height={26} />
      </div>
    )
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.section} id="faq-exe">
          <div className={classes.subheading}>キーマンデータベース検索でよくあるご質問</div>
        </div>
        <div className={classes.section} id="faq-exe1">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerExe1')}>
            <div className={classes.question}>
              <div className={classes.about}>
                特定の会社名で検索すると、検索結果が少ないような場合がありますが、不具合ですか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerExe1 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerExe1 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                着任から5年以上経過したキーマンの情報は、退任した可能性があるためデフォルトで非表示になっております。表示したい場合は、絞り込み条件の項目「着任」から、〇〇年以前も表示するにチェックを入れてください。
              </div>
              <div className={classes.imgContainer}>
                <img
                  alt="faq-img1"
                  src={require('../../assets/images/faq1x2.png')}
                  className={classes.img}
                />
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  ［キーマンデータベース］＞ キーマンの特徴を探す ＞ 〇〇年以前も表示する
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-exe2">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerExe2')}>
            <div className={classes.question}>
              <div className={classes.about}>
                法人番号一括検索で、検索にヒットした法人はどれで、ヒットしなかったのはどれかというのを確認できますか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerExe2 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerExe2 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                法人番号一括検索後、検索結果件数の下に現れる【法人番号での一括検索にて、該当するキーマンがいなかった会社のリストをエクスポート】からご確認いただけます。
              </div>
              <div className={classes.imgContainer}>
                <img
                  alt="faq-img2"
                  src={require('../../assets/images/faq2x2.png')}
                  className={classes.img}
                />
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  ［キーマンデータベース］＞ 法人番号から決済社を一括検索 ＞ 法人番号での一括検索にて、該当するキーマンがいなかった会社のリストをエクスポート
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-exe3">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerExe3')}>
            <div className={classes.question}>
              <div className={classes.about}>
                DUNSナンバーで検索できますか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerExe3 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerExe3 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                できません。
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-exe4">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerExe4')}>
            <div className={classes.question}>
              <div className={classes.about}>
                第三者への個人情報の削除、および提供の停止することはできますか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerExe4 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerExe4 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                いつでもご本人からの請求により第三者への提供を停止いたします。
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdCn_Piqir99Xts2ZTwr8DG42ayrHXSIi-iKnuZyiKJoBM7PQ/viewform?usp=sf_link"
                  target="_blank"
                  rel="noreferrer noopener"
                  className={classes.link}
                  onClick={e => { e.stopPropagation(); }}
                >
                  ご請求はこちらから
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-ordering">
          <div className={classes.subheading} style={{ marginTop: 60 }}>レター注文時によくあるご質問</div>
        </div>
        <div className={classes.section} id="faq-ordering1">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerOrdering1')}>
            <div className={classes.question}>
              <div className={classes.about}>
                データ送付前にどのキーマンが選択されているか、Excel等で一覧で見たいのですが可能ですか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerOrdering1 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerOrdering1 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                できません。注文済みキーマンであれば、ダウンロードすることが可能です。
              </div>
              <div className={classes.imgContainer}>
                <img
                  alt="faq-img3"
                  src={require('../../assets/images/faq3x2.png')}
                  className={classes.img}
                />
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  ［キーマンデータベース］＞ 注文済みキーマンをエクスポート
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-ordering2">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerOrdering2')}>
            <div className={classes.question}>
              <div className={classes.about}>
                QRコードは複数設置することはできますか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerOrdering2 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerOrdering2 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                QRコード自体は複数の設置が可能です。しかし、トラッキングが可能なQRコードはレターにつき1つまでとさせて頂いております。
              </div>
              <div className={classes.detail} style={{ marginTop: 10 }}>
                しかし、QRコードの遷移先をまとめたURL発行するようなサービスをご活用いただければ、1つのURLで複数の遷移先を案内することができます。
              </div>
              <div className={classes.caution}>
                <div className={classes.about} style={{ fontSize: 15, marginBottom: 10 }}>
                  複数のURLをQRコードに含められるサービスの例
                </div>
                <a
                  href="https://qr.quel.jp/form_omatome.php"
                  target="_blank"
                  rel="noreferrer noopener"
                  className={classes.link}
                  onClick={e => { e.stopPropagation(); }}
                >
                  おまとめQR
                </a>
              </div>
              <div className={classes.detail}>
                また、下の記事よりQRコードの活用方法についてご覧いただけます。
              </div>
              <div style={{ marginTop: 15 }}>
                {this.renderArticleLink('QRコードの効果的な活用方法', '会社HPから日程調整URLまで、QRコードのリンク先の事例をご紹介します。QRコードの設定手順についても記載しています。', '/how-to/send-letter/qrcode')}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-ordering3">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerOrdering3')}>
            <div className={classes.question}>
              <div className={classes.about}>
                QRコードのURLを入力したが、入稿データにはQRコードを挿入し忘れてしまいました。
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerOrdering3 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerOrdering3 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                URLを入力いただいた注文で、入稿データに配置箇所の指示がない場合、弊社で適当な箇所にQRコードを設置させていただいております。
              </div>
              <div className={classes.detail} style={{ marginTop: 10 }}>
                QRコードの設置を希望されない場合は、注文時にURLを入力していないことを確認してから注文をお願いいたします。
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-ordering4">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerOrdering4')}>
            <div className={classes.question}>
              <div className={classes.about}>
                自社で保有しているリストで担当者名が分からず、宛名を「ご担当者様」のような形で送付する事は可能ですか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerOrdering4 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerOrdering4 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                自社リストの宛先の名前に記入していただければ、「ご担当者様」のようにレターをお送りすることもできますが、不達の可能性が高まりますので推奨はしておりません。
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-after-order">
          <div className={classes.subheading} style={{ marginTop: 60 }}>レター注文後によくあるご質問</div>
        </div>
        <div className={classes.section} id="faq-after-order1">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerAfterOrder1')}>
            <div className={classes.question}>
              <div className={classes.about}>
                キャンセルしたい場合はどうすればいいですか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerAfterOrder1 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerAfterOrder1 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                {"チャットにてキャンセル申請をお願いいたします。その際、注文Noと、ログインメールアドレスをご共有ください。\n注文から3時間以上経ったレターは、Lightプランだとキャンセルできませんのでご了承くださいませ。また、発送オペレーションの進捗によってはキャンセルできない場合がございます。"}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-after-order2">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerAfterOrder2')}>
            <div className={classes.question}>
              <div className={classes.about}>
                レターが届いたかどうかわかりますか？
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerAfterOrder2 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerAfterOrder2 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                届いたかどうかはわかりかねますが、QRコードを設定し、宛名の方がQRコード読み込んだ場合は届いたことがわかります。
              </div>
            </div>
          </div>
        </div>
        <div className={classes.section} id="faq-after-order3">
          <div className={classes.guide} onClick={() => this.toggleAnswer('showAnswerAfterOrder3')} style={{ marginBottom: 60 }}>
            <div className={classes.question}>
              <div className={classes.about}>
                手紙を送付しましたが、退任されたとのことで返却されました。
              </div>
              <div className={classes.arrow}>
                {this.state.showAnswerAfterOrder3 ? <ArrowUp width={20} height={20} /> : <ArrowDown width={20} height={20} />}
              </div>
            </div>
            <div className={classes.answer} style={{ display: this.state.showAnswerAfterOrder3 ? 'block' : 'none' }}>
              <div className={classes.detail}>
                大変申し訳ございません。退任情報は企業として公開してないケースが多く、不通になる場合がございます。比較的着任年が新しいキーマンにアプローチしていただくと不通になりにくくなります。
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

HowToFaq.propTypes = {
  classes: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  howToMenu: PropTypes.string.isRequired,
};

export default withStyles(styles)(HowToFaq);



// WEBPACK FOOTER //
// ./src/components/Faq/HowToFaq.jsx